import { emptySplitApi } from 'emptySplitApi'

import { AuthResponseType } from './types'

export const authApi = emptySplitApi.injectEndpoints({
  endpoints: build => ({
    verifyToken: build.mutation<AuthResponseType, void>({
      query: () => ({
        url: `auth/verify`,
        method: 'POST',
      }),
    }),
    refreshToken: build.mutation<AuthResponseType, void>({
      query: () => ({
        url: `auth/refresh`,
        method: 'POST',
      }),
    }),
  }),
})

export const { useVerifyTokenMutation, useRefreshTokenMutation } = authApi
